import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=6a6fc8f0&scoped=true&"
import script from "./Opportunities.vue?vue&type=script&lang=js&"
export * from "./Opportunities.vue?vue&type=script&lang=js&"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=6a6fc8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fc8f0",
  null
  
)

export default component.exports